module.exports = __webpack_public_path__ + "img/gallery-add.091c680e.svg";